import { IFormField, IFormSection } from "../web-form.objects"
import { PickListItem } from "../../../entities/pick-list/pick-list.entities";
import _ from "lodash";

export class DropdownInputOptions {
    isMultiselect: boolean = false;
    options: PickListItem[] = undefined;
    sortOptions: boolean = true;
    constructor(isMultiselect: boolean = false, options: PickListItem[] = undefined, sortOptions: boolean = true) {
        this.isMultiselect = isMultiselect;
        this.options = options;
        this.sortOptions = sortOptions;
    }
}

export class DropdownInputField implements IFormField {
    fieldId: string;
    displayName: string;
    isRequired: boolean;
    propertyName: string;
    defaultVal: any;
    forObjProperty: boolean = true;
    shouldTriggerUpdate: boolean = false;

    formSection: IFormSection;

    options: DropdownInputOptions;

    constructor(propertyName: string, defaultVal: any, fieldId: string, displayName: string, isRequired: boolean, options: DropdownInputOptions = new DropdownInputOptions()) {
        this.fieldId = fieldId;
        this.displayName = displayName;
        this.isRequired = isRequired;
        this.propertyName = propertyName;
        this.defaultVal = defaultVal;
        this.options = options;
    }

    initialize(formSection: IFormSection) {
        this.formSection = formSection;

        if (this.options.options != undefined) {
            this.generateDropdown();
        }
        else {
            $(`#${this.fieldId}`).selectpicker({
                dropupAuto: false,
                selectedTextFormat: "count",

                countSelectedText: (numSelected, numTotal) => {
                    if (numSelected == numTotal) {
                        return "All";
                    }
                    else {
                        return numSelected + " Selected";
                    }
                }
            });

            $(`#${this.fieldId}`).selectpicker("refresh");
        }

        this.initializeSectionUpdateTrigger();
    }

    private initializeSectionUpdateTrigger() {
        $(`#${this.fieldId}`).on("changed.bs.select", () => {
            this.triggerSectionUpdate();
        });
    }

    setOptions(newOptions: PickListItem[]) {
        this.options.options = newOptions;
        this.generateDropdown();
    }

    setDisabled(isDisabled: boolean) {
        $(`#${this.fieldId}`).prop("disabled", isDisabled);
        if (this.options.isMultiselect) {
            this.setMultiselectInput('');
        }
        else {
            this.setSingleInput('');
        }
        $(`#${this.fieldId}`).selectpicker("refresh");
    }

    generateDropdown() {
        $(`#${this.fieldId}`).find("option").remove();
        $(`#${this.fieldId}`).selectpicker({
            dropupAuto: false,
            selectedTextFormat: "count",

            countSelectedText: (numSelected, numTotal) => {
                if (numSelected == numTotal) {
                    return "All";
                }
                else {
                    return numSelected + " Selected";
                }
            }
        });

        if (!this.options.isMultiselect) {
            // Add default option with no value to show no input (no favoritism)
            $(`#${this.fieldId}`).append(`<option hidden disabled selected value>-- Select --</option>`);
        }

        if (this.options.sortOptions && this.options.options != undefined) {
            this.options.options.sort((x1, x2) => x1.Value.localeCompare(x2.Value));
        }

        if (this.options.options != undefined) {
            this.options.options.forEach(option => {
                $(`#${this.fieldId}`).append(new Option(option.Value, option.Id.toString(), false, false));
            })
        }

        $(`#${this.fieldId}`).selectpicker("refresh");
    }

    private getInput(): string | string[] {
        if (this.options.isMultiselect) {
            let input = <string[]>$(`#${this.fieldId}`).val();
            return input;
        }
        else {
            let input = <string>$(`#${this.fieldId}`).val();
            return input;
        }
    }

    private setMultiselectInput(data: string) {
        let valArr = data.split("|");
        $(`#${this.fieldId}`).selectpicker("val", valArr);
    }

    private setSingleInput(data: string | number) {
        let strVal = data.toString();
        $(`#${this.fieldId}`).selectpicker("val", strVal);
    }

    private getParsedInput() {
        let val = this.defaultVal;
        let input = this.getInput();
        if (this.options.isMultiselect) {
            val = (<string[]>input).join("|");
        }
        else {
            let stringVal = <string>input;
            let parsedNum = parseInt(stringVal);
            if (parsedNum) {
                val = parsedNum
            }
        }
        return val;
    }

    getValue(): any {
        let val = this.defaultVal;

        let isValid = this.checkValid();
        let isChanged = this.checkChanged();
        if (isValid && isChanged) {
            val = this.getParsedInput();
        }

        return val;
    }

    setValue(formData: any) {
        let formVal = _.get(formData, this.propertyName);
        if (formVal != undefined) {
            if (this.options.isMultiselect) {
                this.setMultiselectInput(formVal);
            }
            else {
                this.setSingleInput(formVal);
            }
        }
    }

    checkValid(): boolean {
        if (this.isRequired) {
            let input = this.getParsedInput();
            // empty
            if (!input) {
                return false;
            }
            return true;
        }
        else {
            return true;
        }
    }

    checkChanged(): boolean {
        let val = this.getParsedInput();
        if (val != this.defaultVal) {
            return true;
        }
        return false;
    }

    displayValid(isValid: boolean) {
        if (isValid) {
            $(`#${this.fieldId}`).siblings(".dropdown-toggle").addClass("is-valid").removeClass("is-invalid");
        }
        else {
            $(`#${this.fieldId}`).siblings(".dropdown-toggle").removeClass("is-valid").addClass("is-invalid");
        }
    }

    resetValidDisplay() {
        $(`#${this.fieldId}`).siblings(".dropdown-toggle").removeClass("is-valid").removeClass("is-invalid");
    }

    triggerSectionUpdate() {
        if (this.formSection && this.shouldTriggerUpdate) {
            this.formSection.updateSection();
        }
    }
}

